// i18n configs
export const defaultLocale = 'en-AU';

// Theme configs
export const isMultiColorActive = false;
export const defaultColor = 'light.default';
export const getDefaultColor = (flavor) => {
  if (flavor !== 'Zii') {
    return defaultColor.replace('default', flavor.toLowerCase());
  }
  return defaultColor;
};
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const colors = [
  'default',
  'cashpoint',
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'redruby',
  'yellowgranola',
  'greysteel',
];
export const themeColorStorageKey = '__theme_selected_color';

// Authorization configs
export const isAuthGuardActive = true;
export const currentUser = {};

// Store configs
export const merchantIdKey = '__merchant_id';
export const branchIdKey = '__branch_id';
export const storeKey = '__store';

// Online Ordering configs
export const orderCartKey = '__order_cart'; // 普通购物车
export const orderMoreCartKey = '__order_more_cart'; // 加菜购物车
export const orderTypeKey = '__order_type';
export const shippingMethodKey = '__shipping_method';
export const mealTypeKey = '__meal_type';
export const orderSourceKey = '__order_source';
export const tableNumKey = '__table_num';
export const orderDetailKey = '__order_detail';
export const orderRelatedBuzIdKey = '__order_related_buz_id';
export const orderBillTypeKey = '__order_bill_type';
export const orderPreferenceKey = '__order_preference';
export const rootOrderKey = '__root_order'; // 主订单
export const categoryMenuKey = '__category_menu'; // 菜单
export const cartNodeKey = '__cart_node'; // 购物车
export const orderPersonsKey = '__order_persons'; // 就餐人数

// ConnectId data
export const connectIdSelectBankResKey = '__connectId_select_bank_res'; // Select Bank Res
export const connectIdOver18Key = '__connectId_over_18'; // Over 18
// AddFlag
export const addFlagKey = '__add_flag'; // 是否加菜

// Session
export const sessionDateKey = '__session_date'; // session date 超过一小时需要清除之前的购物车数据

export const countries = ['AU', 'SG', 'HK', 'NZ', 'JP', 'MY', 'TH', 'VN'];

export * from './defaultValues';
